import React from 'react';
import { Select } from '@mui/material';
import withAddButtonSelect from './withAddButtonSelect';

interface AddButtonSelectProps {
  options: Array<{ id: string; name: string; [key: string]: any }>;
  value: string;
  onChange: (event: any, child?: React.ReactNode) => void;
  onBlur?: (event: any) => void;
  placeholder?: string;
  label?: string;
  size?: 'small' | 'medium';
  fullWidth?: boolean;
  disabled?: boolean;
  required?: boolean;
  onAddNew?: (newItem: { name: string }) => Promise<{ id: string; name: string }>;
  addDialogTitle?: string;
  addDialogLabel?: string;
  addDialogPlaceholder?: string;
  sx?: any;
  // New props for custom dialog support
  CustomDialog?: React.ComponentType<{
    open: boolean;
    onClose: () => void;
    onSave: (data: any) => Promise<any>;
    loading?: boolean;
  } & Record<string, any>>;
  onAddNewCustom?: (data: any) => Promise<{ id: string; name: string }>;
  customDialogProps?: Record<string, any>;
  // Permission control for '+' button visibility
  canAddNew?: boolean;
  // New prop for custom select component
  CustomSelect?: React.ComponentType<{
    value: string;
    onChange: (event: any) => void;
    onBlur?: (event: any) => void;
    options: Array<{ id: string; name: string; [key: string]: any }>;
    placeholder?: string;
    size?: 'small' | 'medium';
    fullWidth?: boolean;
    disabled?: boolean;
    required?: boolean;
  }>;
  showColor?: boolean;
}

const EnhancedSelect = withAddButtonSelect(Select);

const AddButtonSelect: React.FC<AddButtonSelectProps> = (props) => {
  return <EnhancedSelect {...props} />;
};

export default AddButtonSelect;
